import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: 100%;
  flex: 1;
`;

const IdInputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`;

const InputBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface ValidProps {
  isValid: boolean;
  sendYN?: boolean;
  available?: boolean;
  text?: string;
}

const getButtonStyles = (props: ValidProps) => {
  if (props.available) {
    return {
      backgroundColor: '#989BA2',
      color: '#ffffff',
      cursor: 'null',
    };
  }

  if (props.sendYN) {
    return {
      border: '1px solid #008AFF',
      backgroundColor: '#FFFFFF',
      color: '#008AFF',
      cursor: 'pointer',
    };
  }
  if (props.isValid) {
    return {
      backgroundColor: '#008AFF',
      color: '#ffffff',
      cursor: 'pointer',
    };
  }

  return {
    backgroundColor: '#f7f7f8',
    color: '#616161',
    cursor: 'null',
  };
};

const CheckValidButton = styled.div<ValidProps>`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  line-height: 26.4px;
  word-wrap: break-word;
  white-space: nowrap;
  min-width: 111px;
  text-align: center;
  border: ${(props) => getButtonStyles(props).border};
  background-color: ${(props) => getButtonStyles(props).backgroundColor};
  color: ${(props) => getButtonStyles(props).color};
  cursor: ${(props) => getButtonStyles(props).cursor};
`;

const InputInfoBox = styled.div<ValidProps>`
  color: ${(props) => (props.isValid ? 'rgba(55, 56, 60, 0.61)' : '#FF0000')};
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const VisibleButton = styled.div`
  position: absolute;
  top: 53px;
  right: 15px;
  img {
    width: 20px;
    height: 20px;
  }
`;

const SpecialCharTag = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  text-align: left;
  color: rgba(55, 56, 60, 0.61);
  position: absolute;
  top: 14px;
  right: 96px;
  white-space: nowrap;
  margin-bottom: 20px;
`;

export const S = {
  SpecialCharTag,
  VisibleButton,
  InputInfoBox,
  InputBoxWrapper,
  CheckValidButton,
  Wrapper,
  IdInputBox,
};
